import React from "react";

const ToggleSwitch = ({
  checked = false,
  onChange,
  disabled = false,
  className = "",
  size = "md",
  ...props
}) => {
  const sizeClasses = size === "sm" ? "w-10 h-5" : size === "lg" ? "w-16 h-9" : "w-12 h-6";

  const knobSizeClasses = size === "sm" ? "w-4 h-4" : size === "lg" ? "w-7 h-7" : "w-5 h-5";

  // exact travel distance so knob sits inside track
  const translateClasses =
    size === "sm" ? "translate-x-5" : size === "lg" ? "translate-x-7" : "translate-x-6";

  const handleToggle = () => {
    if (!disabled && onChange) onChange(!checked);
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      disabled={disabled}
      className={`
        relative inline-flex items-center
       
        transition-colors duration-200 ease-in-out
        ${sizeClasses}
        ${checked ? "bg-[#8FAF9A]" : "bg-[#E5E7EB]"}
        ${disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer"}
        ${className}
      `}
      style={{
        borderRadius: "10px",
        backgroundColor: checked ? "var(--brand-primary)" : undefined,
      }}
      {...props}
      role="switch"
      aria-checked={checked}
    >
      <span
        style={{
          borderRadius: "10px",
        }}
        className={`
          absolute left-0.5   /* gap from edge */
          bg-white  shadow-sm
          transform transition-transform duration-200 ease-in-out
          ${knobSizeClasses}
          ${checked ? translateClasses : "translate-x-0"}
        `}
      />
    </button>
  );
};

export default ToggleSwitch;
